import { render, staticRenderFns } from "./CriticismColumn.vue?vue&type=template&id=253eb57e&scoped=true&"
import script from "./CriticismColumn.vue?vue&type=script&lang=js&"
export * from "./CriticismColumn.vue?vue&type=script&lang=js&"
import style0 from "./CriticismColumn.vue?vue&type=style&index=0&id=253eb57e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253eb57e",
  null
  
)

export default component.exports